import { render, staticRenderFns } from "./forgotpassword.vue?vue&type=template&id=a927aeac&"
import script from "./forgotpassword.vue?vue&type=script&lang=js&"
export * from "./forgotpassword.vue?vue&type=script&lang=js&"
import style0 from "./forgotpassword.vue?vue&type=style&index=0&id=a927aeac&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports